import { render, staticRenderFns } from "./custom-Input-tag.vue?vue&type=template&id=6f38d604&scoped=true"
import script from "./custom-Input-tag.vue?vue&type=script&lang=js"
export * from "./custom-Input-tag.vue?vue&type=script&lang=js"
import style0 from "./custom-Input-tag.vue?vue&type=style&index=0&id=6f38d604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38d604",
  null
  
)

export default component.exports